import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { FC, forwardRef, ForwardedRef } from 'react';

import getWrappedDisplayName from '../../utils/hocs/getWrappedDisplayName';

export type WithShowProps = {
  show?: boolean;
  hide?: boolean;
};

const withShow = (WrappedComponent: FC<{ ref: ForwardedRef<any> }>) => {
  const WithShow = forwardRef(({ show, hide, ...props }: WithShowProps, ref) => {
    if (hide === true || show === false) return null;

    return (
      <WrappedComponent
        ref={ref}
        {...props}
      />
    );
  });

  WithShow.displayName = getWrappedDisplayName('WithShow', WrappedComponent);

  return hoistNonReactStatics(WithShow, WrappedComponent);
};

export default withShow;
